import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import Solutions from './Pages/Solutions';
import Products from './Pages/Products';
import Contact from './Pages/Contact';
import './styles/theme.css';

/* Scroll to top on route change */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const AppLayout = () => (
  <>
    <ScrollToTop />
    <Navbar />
    <main>
      <Routes>
        <Route path="/about"     element={<About />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/products"  element={<Products />} />
        <Route path="/contact"   element={<Contact />} />
        <Route path="/*"         element={<Home />} />
      </Routes>
    </main>
    <Footer />
  </>
);

const App = () => (
  <BrowserRouter>
    <AppLayout />
  </BrowserRouter>
);

export default App;
